import { observer } from "mobx-react-lite";
import * as React from "react";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { useLocation, useNavigate } from "react-router-dom";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderGenericNodePoolAddRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isDone, setIsDone] = React.useState(false);

  React.useEffect(() => {
    if (isDone) {
      navigate(
        `${pathname.replace("-add", "")}${
          mk8sDraft.provider_generic.nodePools[mk8sDraft.provider_generic.nodePools.length - 1].index
        }`
      );
      return;
    }

    mk8sDraft.provider_generic.addNodePool();
    setIsDone(true);
  }, [isDone]);

  return null;
};

export const ProviderGenericNodePoolAdd = observer(ProviderGenericNodePoolAddRaw);
